import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-rounded-2xl tw-border tw-border-slate-200/70 tw-bg-white/60 tw-backdrop-blur tw-shadow-sm tw-shadow-slate-200/50"
}
const _hoisted_2 = { class: "tw-p-4 sm:tw-p-5" }
const _hoisted_3 = { class: "tw-flex tw-flex-col tw-gap-3 sm:tw-flex-row sm:tw-items-center sm:tw-justify-between" }
const _hoisted_4 = { class: "tw-min-w-0 tw-text-left" }
const _hoisted_5 = { class: "tw-mt-0.5 tw-text-sm tw-text-slate-600" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  key: 0,
  class: "tw-mt-1 tw-text-xs tw-text-slate-500"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "tw-flex tw-flex-wrap tw-items-center tw-justify-end tw-gap-2" }
const _hoisted_11 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-whitespace-nowrap" }
const _hoisted_12 = { class: "tw-mt-3 tw-max-w-xl" }
const _hoisted_13 = {
  key: 0,
  class: "tw-mt-2 tw-text-[11px] tw-text-slate-500"
}
const _hoisted_14 = { class: "tw-font-bold tw-text-slate-800" }
const _hoisted_15 = { class: "tw-border-t tw-border-slate-200/70" }
const _hoisted_16 = { class: "tw-overflow-auto" }
const _hoisted_17 = {
  class: "tw-w-full tw-border-collapse tw-text-left tw-text-sm tw-text-slate-800",
  key: "users-table"
}
const _hoisted_18 = { class: "tw-border-b tw-border-slate-200/70 tw-bg-white/50" }
const _hoisted_19 = {
  key: 0,
  class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700"
}
const _hoisted_20 = { key: 0 }
const _hoisted_21 = ["colspan"]
const _hoisted_22 = { key: 1 }
const _hoisted_23 = ["colspan"]
const _hoisted_24 = { class: "tw-px-4 tw-py-3 tw-text-slate-600" }
const _hoisted_25 = {
  key: 0,
  class: "tw-px-4 tw-py-3 tw-text-slate-700"
}
const _hoisted_26 = { class: "tw-px-4 tw-py-3 tw-font-medium tw-text-slate-900" }
const _hoisted_27 = { class: "tw-px-4 tw-py-3 tw-text-slate-700" }
const _hoisted_28 = { class: "tw-px-4 tw-py-3" }
const _hoisted_29 = { class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-slate-200/70 tw-bg-white/60 tw-px-2.5 tw-py-1 tw-text-xs tw-font-medium tw-text-slate-700" }
const _hoisted_30 = { class: "tw-px-4 tw-py-3" }
const _hoisted_31 = {
  key: 0,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-emerald-200/70 tw-bg-emerald-50/70 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-emerald-900"
}
const _hoisted_32 = {
  key: 1,
  class: "tw-inline-flex tw-items-center tw-rounded-full tw-border tw-border-amber-200/70 tw-bg-amber-50/70 tw-px-2.5 tw-py-1 tw-text-xs tw-font-semibold tw-text-amber-900"
}
const _hoisted_33 = { class: "tw-px-4 tw-py-3" }
const _hoisted_34 = { class: "tw-flex tw-flex-wrap tw-items-center tw-gap-2" }
const _hoisted_35 = ["onClick"]
const _hoisted_36 = ["onClick"]
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 0,
  class: "tw-mt-6 tw-flex tw-justify-center tw-px-4 tw-pb-4"
}
const _hoisted_39 = { class: "tw-space-y-4" }
const _hoisted_40 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3" }
const _hoisted_41 = { class: "tw-flex tw-items-end" }
const _hoisted_42 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700 tw-w-full tw-h-[40px]" }
const _hoisted_43 = { class: "tw-mt-5 tw-flex tw-justify-end tw-gap-2" }
const _hoisted_44 = { class: "tw-space-y-4" }
const _hoisted_45 = { class: "tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-3" }
const _hoisted_46 = { class: "tw-rounded-xl tw-border tw-border-slate-200 tw-bg-slate-50 tw-px-3 tw-py-2 tw-text-sm tw-text-slate-600" }
const _hoisted_47 = { class: "tw-flex tw-flex-col tw-gap-3 tw-justify-end" }
const _hoisted_48 = { class: "tw-inline-flex tw-items-center tw-gap-2 tw-text-sm tw-text-slate-700" }
const _hoisted_49 = { class: "tw-mt-5 tw-flex tw-justify-end tw-gap-2" }
const _hoisted_50 = { class: "tw-space-y-4" }
const _hoisted_51 = { class: "tw-text-sm tw-text-slate-700" }
const _hoisted_52 = { class: "tw-font-semibold tw-text-slate-900" }
const _hoisted_53 = { class: "tw-mt-5 tw-flex tw-justify-end tw-gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_PaginationBar = _resolveComponent("PaginationBar")!
  const _component_InputField = _resolveComponent("InputField")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_ctx.company)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[14] || (_cache[14] = _createElementVNode("div", { class: "tw-text-base tw-font-semibold tw-text-slate-900" }, "Users", -1)),
              _createElementVNode("div", _hoisted_5, [
                (_ctx.showAllUsers)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "All users on the platform."))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7, "Manage access for your company."))
              ]),
              (_ctx.total)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createTextVNode(_toDisplayString(_ctx.total) + " user" + _toDisplayString(_ctx.total === 1 ? '' : 's') + " ", 1),
                    (_ctx.pageCount > 1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, " · page " + _toDisplayString(_ctx.pageNum + 1) + " of " + _toDisplayString(_ctx.pageCount), 1))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, [
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "Rows", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
                  class: "tw-rounded-lg tw-border tw-border-slate-200 tw-bg-white/70 tw-px-2 tw-py-1.5 tw-text-sm tw-text-slate-900 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-slate-900/10"
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("option", { value: 10 }, "10", -1),
                  _createElementVNode("option", { value: 25 }, "25", -1),
                  _createElementVNode("option", { value: 50 }, "50", -1),
                  _createElementVNode("option", { value: 100 }, "100", -1)
                ]))], 512), [
                  [
                    _vModelSelect,
                    _ctx.pageSize,
                    void 0,
                    { number: true }
                  ]
                ])
              ]),
              (_ctx.canToggleAllUsers)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: _normalizeClass(["tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-shadow-sm tw-shadow-slate-900/5", _ctx.showAllUsers
              ? 'tw-border-slate-900 tw-bg-slate-900 tw-text-white hover:tw-bg-slate-800'
              : 'tw-border-slate-200/70 tw-bg-white/70 tw-text-slate-700 hover:tw-bg-white']),
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleAllUsersView && _ctx.toggleAllUsersView(...args)))
                  }, _toDisplayString(_ctx.showAllUsers ? 'My company only' : 'All users'), 3))
                : _createCommentVNode("", true),
              (!_ctx.showAllUsers)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    type: "button",
                    class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-slate-700 tw-shadow-sm tw-shadow-slate-900/5 hover:tw-bg-white",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openAddUserModal && _ctx.openAddUserModal(...args)))
                  }, " Add New User "))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_SearchInput, {
              modelValue: _ctx.searchInput,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchInput) = $event)),
              onSearch: _ctx.searchTermChanged,
              placeholder: "Search by name or email…"
            }, null, 8, ["modelValue", "onSearch"]),
            (_ctx.searchTerm)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _cache[17] || (_cache[17] = _createTextVNode(" Searching for: ", -1)),
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.searchTerm), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("table", _hoisted_17, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_18, [
                  _cache[18] || (_cache[18] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "#", -1)),
                  (_ctx.showAllUsers)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_19, "Company"))
                    : _createCommentVNode("", true),
                  _cache[19] || (_cache[19] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Name", -1)),
                  _cache[20] || (_cache[20] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Email", -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Role", -1)),
                  _cache[22] || (_cache[22] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Status", -1)),
                  _cache[23] || (_cache[23] = _createElementVNode("th", { class: "tw-whitespace-nowrap tw-px-4 tw-py-3 tw-font-semibold tw-text-slate-700" }, "Actions", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_ctx.companyUsersLoading && !_ctx.users.length)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_20, [
                      _createElementVNode("td", {
                        colspan: _ctx.tableColumnCount,
                        class: "tw-px-4 tw-py-8 tw-text-center tw-text-slate-500"
                      }, " Loading users… ", 8, _hoisted_21)
                    ]))
                  : (!_ctx.users.length)
                    ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                        _createElementVNode("td", {
                          colspan: _ctx.tableColumnCount,
                          class: "tw-px-4 tw-py-8 tw-text-center tw-text-slate-500"
                        }, " No users found. ", 8, _hoisted_23)
                      ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (companyUser, userIdx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: companyUser.id,
                    class: "tw-border-b tw-border-slate-200/50 hover:tw-bg-slate-50/70"
                  }, [
                    _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.rowNumber(userIdx)), 1),
                    (_ctx.showAllUsers)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_25, _toDisplayString(companyUser.company?.name || '—'), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_26, _toDisplayString(companyUser.fullName), 1),
                    _createElementVNode("td", _hoisted_27, _toDisplayString(companyUser.email), 1),
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.formatUserRole(companyUser)), 1)
                    ]),
                    _createElementVNode("td", _hoisted_30, [
                      (companyUser.isActive !== false)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_31, " Active "))
                        : (_openBlock(), _createElementBlock("span", _hoisted_32, " Inactive "))
                    ]),
                    _createElementVNode("td", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        (_ctx.canEditUser(companyUser))
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                              onClick: ($event: any) => (_ctx.openEditUserModal(companyUser)),
                              title: "Edit user"
                            }, " Edit ", 8, _hoisted_35))
                          : _createCommentVNode("", true),
                        (_ctx.canEditUser(companyUser) && companyUser.isActive !== false)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 1,
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-rose-200/70 tw-bg-rose-50/70 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-rose-900 hover:tw-bg-rose-50",
                              onClick: ($event: any) => (_ctx.openConfirmUserStatus(companyUser, false)),
                              title: "Deactivate this user"
                            }, " Deactivate ", 8, _hoisted_36))
                          : _createCommentVNode("", true),
                        (_ctx.canEditUser(companyUser) && companyUser.isActive === false)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "tw-inline-flex tw-items-center tw-rounded-xl tw-border tw-border-slate-200/70 tw-bg-white/70 tw-px-3 tw-py-1.5 tw-text-xs tw-font-semibold tw-text-slate-700 hover:tw-bg-white",
                              onClick: ($event: any) => (_ctx.openConfirmUserStatus(companyUser, true)),
                              title: "Activate this user"
                            }, " Activate ", 8, _hoisted_37))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]),
        (_ctx.pageCount > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
              _createVNode(_component_PaginationBar, {
                page: _ctx.pageNum,
                totalPages: _ctx.pageCount,
                disabled: !!_ctx.companyUsersLoading,
                onPreviousPage: _ctx.prevPage,
                onNextPage: _ctx.nextPage,
                onGoToPage: _ctx.goToPage
              }, null, 8, ["page", "totalPages", "disabled", "onPreviousPage", "onNextPage", "onGoToPage"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_Modal, {
          isOpen: _ctx.isAddUserModalOpen,
          "onUpdate:isOpen": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isAddUserModalOpen) = $event)),
          modalId: "admin-users-add-modal",
          maxWidth: "2xl",
          onClose: _ctx.closeAddUserModal
        }, {
          title: _withCtx(() => [...(_cache[24] || (_cache[24] = [
            _createTextVNode("Add new user", -1)
          ]))]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _createVNode(_component_InputField, {
                  modelValue: _ctx.additionUser.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.additionUser.name) = $event)),
                  label: "Name",
                  autocomplete: "username"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  modelValue: _ctx.additionUser.email,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.additionUser.email) = $event)),
                  label: "Email",
                  autocomplete: "email"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_InputField, {
                  modelValue: _ctx.additionUser.password,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.additionUser.password) = $event)),
                  label: "Password",
                  type: "password",
                  autocomplete: "new-password"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_41, [
                  _createElementVNode("label", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "addition_user.isAdmin",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.additionUser.isAdmin) = $event)),
                      class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.additionUser.isAdmin]
                    ]),
                    _cache[25] || (_cache[25] = _createTextVNode(" Is admin ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_43, [
                _createVNode(_component_Button, {
                  isGreen: true,
                  icon: "check",
                  onClick: _ctx.saveUser
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode("Save", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_Button, {
                  isRed: true,
                  isSecondary: true,
                  onClick: _ctx.closeAddUserModal
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen", "onClose"]),
        _createVNode(_component_Modal, {
          isOpen: _ctx.isEditUserModalOpen,
          "onUpdate:isOpen": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isEditUserModalOpen) = $event)),
          modalId: "admin-users-edit-modal",
          maxWidth: "2xl",
          onClose: _ctx.closeEditUserModal
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.editUserModalTitle), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _createVNode(_component_InputField, {
                  modelValue: _ctx.editingUser.name,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.editingUser.name) = $event)),
                  label: "Name",
                  autocomplete: "name"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", null, [
                  _cache[28] || (_cache[28] = _createElementVNode("div", { class: "tw-block tw-mb-1 tw-text-xs tw-font-medium tw-uppercase tw-tracking-wide tw-text-slate-500" }, " Email ", -1)),
                  _createElementVNode("div", _hoisted_46, _toDisplayString(_ctx.editingUser.email || '—'), 1)
                ]),
                _createVNode(_component_InputField, {
                  modelValue: _ctx.editingUser.password,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.editingUser.password) = $event)),
                  label: "New password",
                  type: "password",
                  autocomplete: "new-password",
                  placeholder: "Leave blank to keep current password"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("label", _hoisted_48, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.editingUser.isAdmin) = $event)),
                      class: "tw-h-4 tw-w-4 tw-rounded tw-border-slate-300"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.editingUser.isAdmin]
                    ]),
                    _cache[29] || (_cache[29] = _createTextVNode(" Company admin ", -1))
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_49, [
                _createVNode(_component_Button, {
                  isGreen: true,
                  icon: "check",
                  enableLoading: _ctx.isSavingEditUser,
                  disabled: _ctx.isSavingEditUser,
                  onClick: _ctx.saveEditedUser
                }, {
                  default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                    _createTextVNode(" Save ", -1)
                  ]))]),
                  _: 1
                }, 8, ["enableLoading", "disabled", "onClick"]),
                _createVNode(_component_Button, {
                  isRed: true,
                  isSecondary: true,
                  disabled: _ctx.isSavingEditUser,
                  onClick: _ctx.closeEditUserModal
                }, {
                  default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                    _createTextVNode(" Cancel ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen", "onClose"]),
        _createVNode(_component_Modal, {
          isOpen: _ctx.isConfirmUserStatusModalOpen,
          "onUpdate:isOpen": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.isConfirmUserStatusModalOpen) = $event)),
          modalId: "admin-users-confirm-status-modal",
          maxWidth: "lg",
          onClose: _ctx.closeConfirmUserStatus
        }, {
          title: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.confirmUserStatusTitle), 1)
          ]),
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_50, [
              _createElementVNode("div", _hoisted_51, [
                _createTextVNode(" Are you sure you want to " + _toDisplayString(_ctx.pendingUserStatusIsActive ? 'activate' : 'deactivate') + " ", 1),
                _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.pendingUserDisplayName), 1),
                _cache[32] || (_cache[32] = _createTextVNode("? ", -1))
              ]),
              _createElementVNode("div", _hoisted_53, [
                (_ctx.pendingUserStatusIsActive)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      isGreen: true,
                      icon: "check",
                      disabled: !_ctx.pendingUserId,
                      onClick: _ctx.confirmUserStatus
                    }, {
                      default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                        _createTextVNode(" Activate ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      isRed: true,
                      icon: "check",
                      disabled: !_ctx.pendingUserId,
                      onClick: _ctx.confirmUserStatus
                    }, {
                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                        _createTextVNode(" Deactivate ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["disabled", "onClick"])),
                _createVNode(_component_Button, {
                  isRed: true,
                  isSecondary: true,
                  onClick: _ctx.closeConfirmUserStatus
                }, {
                  default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                    _createTextVNode("Cancel", -1)
                  ]))]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["isOpen", "onClose"])
      ]))
    : _createCommentVNode("", true)
}